import { useEffect, useState } from "react";
import { LocalBuzzContent } from "../components/news_components/local-buzz-content";
import MainLayout from "../components/MainLayout";
import NewsSidebar from "../components/news_components/news-sidebar";
import { successToast,errorToast } from '../utils/toasters'
import { getNews } from "../services/news";
import { Loader2 } from "lucide-react";

export default function NewsPage() {
  const [newsData, setNewsData] = useState([]);
  const [isProcessing, setIsProcessing] = useState(false);

  useEffect(() => {
    async function newsFetcher() {
      try {
        setIsProcessing(true);
        const newsResponse = await getNews();
        setNewsData(newsResponse);
      } catch (error) {
        console.error("Error while fetching News", error);
        errorToast("Error while fetching News");
      } finally {
        setIsProcessing(false);
      }
    }
    newsFetcher();
  }, []);

  return (
    <>
      {isProcessing ? (
        <div className="fixed inset-0 bg-gray-500 bg-opacity-50 flex items-center justify-center z-50">
          <Loader2 className="animate-spin" width={64} height={64} />
        </div>
      ) : (
        <MainLayout
          rightSidebar={<NewsSidebar newsData={newsData} />}
          rs={true}
        >
          {newsData &&
            newsData.length > 0 && <LocalBuzzContent newsData={newsData} />}
        </MainLayout>
      )};
    </>
  );
}
